import React, { Component } from "react";
import { Button, Col, Row, Label, InputGroup } from "reactstrap";
import { observer } from "mobx-react";
import Card from "../../comum/components/Card";
import InputFiltro from "../../comum/components/InputFiltro";
import CalendarioPicker from "../../comum/components/Calendario";

@observer
export default class FiltrosAgendVgm extends Component {
  msgAlertaFiltroData = () => {
    if (this.props.filtros.dataFinal - this.props.filtros.dataInicial > 30) {
      return "Período deve ser menor que 30 dias";
    }
  };

  render() {
    return (
      <div className="filtro-card">
        <Card className={`area-form pb-0`}>
          <Row className="pb-0">
                <InputFiltro
                  titulo="Container"
                  xl={2}
                  lg={2}
                  md={3}
                  sm={4}
                  xs={12}
                  className=""
                  onEnter={() => this.props.handleFiltrar()}
                  onChange={event =>
                    this.props.onChangeFiltro("container", event.target.value)
                  }
                  autoFocus={true}
                />
                <Col className="mb-4" lg={5} md={5} sm={8} xs={12}>
                  <Col>
                    <Label>Data Solicitação</Label>
                  </Col>
                  <Col>
                    <InputGroup>
                      <CalendarioPicker
                        onChangeInicio={valor =>
                          this.props.onChangeFiltro("dataInicial", valor)
                        }
                        onChangeFim={valor =>
                          this.props.onChangeFiltro("dataFinal", valor)
                        }
                        dataInicial={this.props.filtros.dataInicial}
                        dataFinal={this.props.filtros.dataFinal}
                        close={true}
                        maxDiasPermitido={30}
                      />
                    </InputGroup>
                  </Col>
                </Col>
                <Col className="px-0 mt-1" xs={12} sm={3} md={2} lg={2}>
                    <Button 
                        className="mt-3 btn-com-bordas-primary btn-filtrar"
                        onClick={() => this.props.handleFiltrar()}
                    >
                        Filtrar
                    </Button>
                </Col>
          </Row>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agend-vgm/componentes/FiltrosAgendVgm.js